import { serviceImageActionsFactory } from '../factories/serviceImageActionsFactory.ts';
import useAddFuelingServiceImage from './useAddFuelingServiceImage.ts';
import useRemoveFuelingServiceImage from './useRemoveFuelingServiceImage.ts';
import useFuelingServiceImages from './useFuelingServiceImages.ts';

export const useFuelingServiceImageActions = serviceImageActionsFactory({
  useAdd: useAddFuelingServiceImage,
  useRemove: useRemoveFuelingServiceImage,
  useImages: useFuelingServiceImages,
  queryKey: (id) => ['fuelingServices', id],
});
